import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Long: { input: number; output: number };
};

/** Additional item to buy or rent */
export type AdditionalItem = {
    __typename?: 'AdditionalItem';
    /** Booking details for buying the product. */
    buy?: Maybe<Product>;
    /** Short description for item from PIM. */
    description?: Maybe<Scalars['String']['output']>;
    /** Long text for popup box from PIM. */
    moreDetails: Scalars['String']['output'];
    /** Name for item from PIM. */
    name?: Maybe<Scalars['String']['output']>;
    /** Name alternate human description for item from PIM. */
    nameAlternate?: Maybe<Scalars['String']['output']>;
    /** back reference for parent group;ex. MagentaTV/160 */
    parentGroupId: Scalars['Long']['output'];
    /** Indicate to remove item before sending the order. */
    removeFromCart?: Maybe<Scalars['Boolean']['output']>;
    /** Booking details for renting the product. */
    rent?: Maybe<Product>;
    /** Identifier based on PIM and internal calculations. */
    uid: Scalars['Long']['output'];
};

/** Group which contains the additional items. */
export type AdditionalItemGroup = {
    __typename?: 'AdditionalItemGroup';
    /** Items contained in group */
    additionalItems?: Maybe<Array<Maybe<AdditionalItem>>>;
    /** Short description for group from PIM. */
    description?: Maybe<Scalars['String']['output']>;
    /** Long text for popup box from PIM. */
    moreDetails?: Maybe<Scalars['String']['output']>;
    /** Name for the group from PIM. */
    name: Scalars['String']['output'];
    /** Indicator wether multiple items are allowed */
    role?: Maybe<Scalars['Long']['output']>;
    /** Identifier */
    uid: Scalars['Long']['output'];
};

/** Group which contains the additional items. */
export type AdditionalItemGroupAdditionalItemsArgs = {
    additionalItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Address = {
    __typename?: 'Address';
    areaCode?: Maybe<Scalars['String']['output']>;
    city: Scalars['String']['output'];
    houseNumber: Scalars['String']['output'];
    klsId?: Maybe<Scalars['Int']['output']>;
    street: Scalars['String']['output'];
    zip: Scalars['String']['output'];
};

export type AutoConfig = {
    __typename?: 'AutoConfig';
    companionProducts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    options?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    product?: Maybe<Scalars['Int']['output']>;
};

/** Bandwidth details for product */
export type Bandwidth = {
    __typename?: 'Bandwidth';
    /** Max provided bandwidth */
    max: Scalars['String']['output'];
    /** Max provided bandwidth speed */
    maxSpeed: Scalars['Float']['output'];
    /** Min provided bandwidth */
    min: Scalars['String']['output'];
    /** Min provided bandwidth speed */
    minSpeed: Scalars['Float']['output'];
    /** Average provided bandwidth */
    regular: Scalars['String']['output'];
    /** Average provided bandwidth speed */
    regularSpeed: Scalars['Float']['output'];
};

export type CheckAvailabilityInput = {
    city: Scalars['String']['input'];
    houseNumber: Scalars['String']['input'];
    street: Scalars['String']['input'];
    zip: Scalars['String']['input'];
};

export type CheckAvailabilityResponse = {
    __typename?: 'CheckAvailabilityResponse';
    address: CheckAvailabilityResponseAddress;
    products: Array<Scalars['Int']['output']>;
};

export type CheckAvailabilityResponseAddress = {
    __typename?: 'CheckAvailabilityResponseAddress';
    areaCode: Scalars['String']['output'];
};

export type Condition = {
    __typename?: 'Condition';
    id?: Maybe<Scalars['Long']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** Total costs structure for the cart */
export type ConfigurationCosts = {
    __typename?: 'ConfigurationCosts';
    /** Costs for the additional items. */
    additionalItems?: Maybe<Array<Maybe<ItemCosts>>>;
    /** Costs for only the product. */
    product?: Maybe<Costs>;
    /** Costs for the whole cart. */
    total?: Maybe<Costs>;
};

export type ContractProducts = {
    __typename?: 'ContractProducts';
    dslOrder: DslOrder;
};

export type Contracts = {
    __typename?: 'Contracts';
    products: ContractProducts;
};

/** Fixed costs */
export type CostFix = {
    __typename?: 'CostFix';
    /** Amount in euro */
    amount: Scalars['Float']['output'];
};

/** Variable costs */
export type CostPoint = {
    __typename?: 'CostPoint';
    /** Amount in euro */
    amount: Scalars['Float']['output'];
    /** Start month of costs */
    from: Scalars['Int']['output'];
    /** End month of costs */
    to?: Maybe<Scalars['Int']['output']>;
};

/** Costs of an item in the cart */
export type Costs = {
    __typename?: 'Costs';
    /** Campaign identifiers applied from AAX */
    campaigns?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
    /** Charges identifiers from AAX */
    charges?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
    /** Condition identifiers from SAP */
    conditions?: Maybe<Array<Maybe<Condition>>>;
    /** Discount identifiers from AAX */
    discounts?: Maybe<Array<Maybe<Discount>>>;
    /** Monthly payable costs */
    monthly: Array<Maybe<CostPoint>>;
    /** Onetime costs; setup/hardware */
    oneTime?: Maybe<CostFix>;
    /** Human description for a permanent discount */
    permanentDiscount?: Maybe<Scalars['String']['output']>;
    /** Shipping costs */
    shipping?: Maybe<CostFix>;
};

export type CreateSessionInput = {
    sessionContext: SessionContextInput;
    vbIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSessionResponse = {
    __typename?: 'CreateSessionResponse';
    session: Session;
};

export type Customer = {
    __typename?: 'Customer';
    mainAddress: Address;
};

export type CustomerInformation = {
    __typename?: 'CustomerInformation';
    contracts: Contracts;
    customer: Customer;
};

/** What does the customer want to do */
export enum CustomerProcess {
    /** Change the product; up-/downgrade */
    Change = 'CHANGE',
    /** Extend the contract duration */
    ContractRenewal = 'CONTRACT_RENEWAL',
    /** New contract */
    New = 'NEW',
}

export enum CustomerProcessType {
    Change = 'CHANGE',
    ContractRenewal = 'CONTRACT_RENEWAL',
    Current = 'CURRENT',
    New = 'NEW',
}

/** Where did we get the customer details from */
export enum CustomerSource {
    Aax = 'AAX',
    Crmt = 'CRMT',
}

/** CustomerType in regards of the AAX */
export enum CustomerType {
    /** Already existing in AAX */
    Existing = 'EXISTING',
    /** Not in AAX; does not have an existing provider */
    New = 'NEW',
    /** Not in AAX; does have an existing provider */
    ProviderChange = 'PROVIDER_CHANGE',
    /** Deprecated type */
    TheOldNew = 'THE_OLD_NEW',
}

/** Discount applied for display in FE */
export type Discount = {
    __typename?: 'Discount';
    /** Internal identifier */
    id?: Maybe<Scalars['Long']['output']>;
    /** Name of the discount */
    name?: Maybe<Scalars['String']['output']>;
};

export type DslOrder = {
    __typename?: 'DslOrder';
    installationAddress: InstallationAddress;
};

export type InstallationAddress = {
    __typename?: 'InstallationAddress';
    address: Address;
};

/** All costs for a single item from the cart. */
export type ItemCosts = {
    __typename?: 'ItemCosts';
    /** Cost details. */
    costs?: Maybe<Costs>;
    /** Identifier of item. */
    id?: Maybe<Scalars['Long']['output']>;
};

/** Is the customer using this for business purposes */
export enum LegalType {
    /** Business of any type */
    Business = 'BUSINESS',
    /** Private user */
    Private = 'PRIVATE',
}

export type Mutation = {
    __typename?: 'Mutation';
    checkAvailability: CheckAvailabilityResponse;
    createSession: CreateSessionResponse;
    searchCustomer: SearchCustomerResponse;
    updateSessionContext: SessionContext;
};

export type MutationCheckAvailabilityArgs = {
    input: CheckAvailabilityInput;
};

export type MutationCreateSessionArgs = {
    input: CreateSessionInput;
};

export type MutationSearchCustomerArgs = {
    input: SearchCustomerInput;
};

export type MutationUpdateSessionContextArgs = {
    input: SessionContextInput;
};

export type PluginSettings = {
    __typename?: 'PluginSettings';
    aaxNotAvailable: Scalars['String']['output'];
    address?: Maybe<Address>;
    autoConfig?: Maybe<AutoConfig>;
    crmtContractSearchEnabled?: Maybe<Scalars['Boolean']['output']>;
    customerType?: Maybe<CustomerType>;
    isYoung?: Maybe<Scalars['Boolean']['output']>;
    linkToCheckout: Scalars['String']['output'];
    linkToProductConfig: Scalars['String']['output'];
    linkToProductOverview: Scalars['String']['output'];
    linkToVp: Scalars['String']['output'];
    noProductsAvailable: Scalars['String']['output'];
    productType: ProductType;
    sellerId: Scalars['String']['output'];
};

/** One concrete product item in cart; tariff, buy or rent. */
export type Product = {
    __typename?: 'Product';
    /** Short/postfix id of item */
    aaxId?: Maybe<Scalars['Long']['output']>;
    /** Identifier for AGB */
    agbId?: Maybe<Scalars['Long']['output']>;
    /** Companion bundled with Option */
    bundleCompanionId?: Maybe<Scalars['Long']['output']>;
    /** Text to describe cancellation requirements in VZI/VZF */
    cancellationText?: Maybe<Scalars['String']['output']>;
    /** Simple description for checkout from PIM. */
    checkoutDescription: Scalars['String']['output'];
    /** Costs for the item with session applied. */
    costs?: Maybe<Costs>;
    /** Indicate that this is a crmt service */
    crmtService?: Maybe<Scalars['Boolean']['output']>;
    /** Name to pass to indicate which crmt service is requested */
    crmtServiceName?: Maybe<Scalars['String']['output']>;
    /** Material number inside of TCK. */
    materialNumber?: Maybe<Scalars['String']['output']>;
    /** Name from PIM */
    name: Scalars['String']['output'];
    /** Full id of item */
    uid?: Maybe<Scalars['Long']['output']>;
    /** Text to describe product in VZI/VZF */
    vviDescription?: Maybe<Scalars['String']['output']>;
    /** Identifier for VZI/VZF withdrawal texts */
    withdrawalId?: Maybe<Scalars['Long']['output']>;
};

export type ProductConfiguration = {
    __typename?: 'ProductConfiguration';
    companionProducts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    options?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    product: Scalars['Int']['output'];
};

/** Product range this user can see */
export enum ProductType {
    /** DOCSIS - Cabel-TV */
    Docsis = 'DOCSIS',
    /** Fiber To The X */
    Fttx = 'FTTX',
}

/** Queries for our application. */
export type Query = {
    __typename?: 'Query';
    availableProducts?: Maybe<Array<Scalars['Int']['output']>>;
    /** Get complete costs for cart content. */
    configuration?: Maybe<ConfigurationCosts>;
    customerInformation: CustomerInformation;
    /** Just an empty query to define a base type that each specialization includes. */
    empty?: Maybe<Scalars['String']['output']>;
    productConfiguration?: Maybe<ProductConfiguration>;
    searchResultUuid: Scalars['String']['output'];
    /** Get one service group by identifier. */
    serviceGroup?: Maybe<ServiceGroup>;
    /** Get the service groups which contain the supplied products. */
    serviceGroups?: Maybe<Array<Maybe<ServiceGroup>>>;
    session: Session;
    sessionContext: SessionContext;
    /** Get one tariff by identifier. */
    tariff?: Maybe<Tariff>;
    /** Get tariffs by identifier. */
    tariffs?: Maybe<Array<Maybe<Tariff>>>;
    verifiedAddress?: Maybe<Address>;
};

/** Queries for our application. */
export type QueryConfigurationArgs = {
    additionalItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
    availableCampaignList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
    customerProcess?: InputMaybe<CustomerProcess>;
    customerType?: InputMaybe<CustomerType>;
    manualCampaignList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
    tariffId?: InputMaybe<Scalars['Long']['input']>;
};

/** Queries for our application. */
export type QueryCustomerInformationArgs = {
    searchUuid: Scalars['String']['input'];
};

/** Queries for our application. */
export type QueryServiceGroupArgs = {
    id?: InputMaybe<Scalars['Long']['input']>;
};

/** Queries for our application. */
export type QueryServiceGroupsArgs = {
    tariffIdList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Queries for our application. */
export type QueryTariffArgs = {
    availableCampaignList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
    customerProcess?: InputMaybe<CustomerProcess>;
    customerType?: InputMaybe<CustomerType>;
    id?: InputMaybe<Scalars['Long']['input']>;
    manualCampaignList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Queries for our application. */
export type QueryTariffsArgs = {
    tariffIdList?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Restrictions for servicegroups */
export enum RestrictionType {
    /** Provides only data and no phone */
    DataOnly = 'DATA_ONLY',
    /** No restrictions */
    None = 'NONE',
    /** Needs special multimedia outlet */
    NoMultimediaOutlet = 'NO_MULTIMEDIA_OUTLET',
}

/** Ribbon for top of servicegroup advertising in FE */
export type Ribbon = {
    __typename?: 'Ribbon';
    /** Color for ribbon in #RRGGBB notation. */
    color: Scalars['String']['output'];
    /** Text for ribbon */
    text: Scalars['String']['output'];
};

export type SearchCustomerEnvelope = {
    __typename?: 'SearchCustomerEnvelope';
    customer: Customer;
};

export type SearchCustomerInput = {
    customerNumber: Scalars['String']['input'];
    phone: SearchCustomerInputPhone;
};

export type SearchCustomerInputPhone = {
    areaCode: Scalars['String']['input'];
    cli: Scalars['String']['input'];
};

export type SearchCustomerResponse = {
    __typename?: 'SearchCustomerResponse';
    uuid: Scalars['String']['output'];
};

/** Service group to bundle products with the same bandwidth;ie. M/L/XL/..... */
export type ServiceGroup = {
    __typename?: 'ServiceGroup';
    /** Textual bandwidth range from PIM */
    bandwidth: Scalars['String']['output'];
    /** Description text from PIM with HTML markup. */
    description: Scalars['String']['output'];
    /** Link to the detailed tariff description. */
    detailsLink?: Maybe<Scalars['String']['output']>;
    /** Disturber text from PIM. */
    disturber?: Maybe<Scalars['String']['output']>;
    /** URL for footnote on disturber. */
    disturberFootnoteURL?: Maybe<Scalars['String']['output']>;
    /** URL for footnote on price. */
    fromPriceFootnoteURL?: Maybe<Scalars['String']['output']>;
    /** Marketing text from PIM */
    marketingSubtext?: Maybe<Scalars['String']['output']>;
    /** Name for group from PIM */
    name: Scalars['String']['output'];
    /** Restrictions; NONE, DATA_ONLY,NO_MULTIMEDIA_OUTLET */
    restrictions?: Maybe<RestrictionType>;
    /** Ribbon to put on top. */
    ribbon?: Maybe<Ribbon>;
    /** Order inside of service groups. */
    sorting: Scalars['Int']['output'];
    /** Tariffs contained in group. */
    tariffs?: Maybe<Array<Maybe<Tariff>>>;
    /** Identifier from AAX */
    uid: Scalars['Long']['output'];
};

export type Session = {
    __typename?: 'Session';
    agentName: Scalars['String']['output'];
    clientIp: Scalars['String']['output'];
    distributionChannelId: Scalars['Int']['output'];
    partnerId: Scalars['String']['output'];
    partnerName: Scalars['String']['output'];
    sessionContext: SessionContext;
    sessionId: Scalars['String']['output'];
    tvo: Scalars['String']['output'];
    vbIdentifier: Scalars['String']['output'];
};

export type SessionContext = {
    __typename?: 'SessionContext';
    customerProcess?: Maybe<CustomerProcess>;
    customerSource?: Maybe<CustomerSource>;
    customerType?: Maybe<CustomerType>;
    isYoung?: Maybe<Scalars['Boolean']['output']>;
    productType?: Maybe<ProductType>;
    shopType?: Maybe<ShopType>;
};

export type SessionContextInput = {
    customerProcess?: InputMaybe<CustomerProcess>;
    customerType?: InputMaybe<CustomerType>;
    productType?: InputMaybe<ProductType>;
    shopType?: InputMaybe<ShopType>;
};

/** Shop from which the user logged in. */
export enum ShopType {
    /** Customer Self Care */
    Csc = 'CSC',
    /** WPP with long distance (ie. phone support) */
    Distance = 'DISTANCE',
    /** WPP with local retailer */
    Retail = 'RETAIL',
    /** regular Webshop */
    Webshop = 'WEBSHOP',
}

/** Tariff which delivers internet connectivity. */
export type Tariff = {
    __typename?: 'Tariff';
    /** Additional item groups available according to current session. */
    additionalItemGroups?: Maybe<Array<Maybe<AdditionalItemGroup>>>;
    /** Which type of customers may buy product. */
    allowedCustomerLegalTypes?: Maybe<Array<Maybe<LegalType>>>;
    /** Which customer process is valid to buy product */
    allowedCustomerProcesses?: Maybe<Array<Maybe<CustomerProcessType>>>;
    contractDurationDescription?: Maybe<Scalars['String']['output']>;
    contractDurationInMonth?: Maybe<Scalars['Int']['output']>;
    /** Bandwidth details for download */
    download?: Maybe<Bandwidth>;
    flexTariff?: Maybe<Scalars['Boolean']['output']>;
    /** Details for material */
    product: Product;
    /** Group this product belongs to. */
    serviceGroup: ServiceGroup;
    /** Indicator to show DOCSIS or FTTX. */
    serviceType: Scalars['Int']['output'];
    /** Tariff id from AAX. */
    tariffId?: Maybe<Scalars['Int']['output']>;
    /** Total costs of tariff with additional products. */
    total?: Maybe<Costs>;
    /** Identifier from AAX. */
    uid: Scalars['Long']['output'];
    /** Bandwidth details for upload */
    upload?: Maybe<Bandwidth>;
    youngTariff?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckAvailabilityMutationVariables = Exact<{
    input: CheckAvailabilityInput;
}>;

export type CheckAvailabilityMutation = {
    __typename?: 'Mutation';
    checkAvailability: {
        __typename?: 'CheckAvailabilityResponse';
        products: Array<number>;
        address: { __typename?: 'CheckAvailabilityResponseAddress'; areaCode: string };
    };
};

export type CreateSessionMutationVariables = Exact<{
    input: CreateSessionInput;
}>;

export type CreateSessionMutation = {
    __typename?: 'Mutation';
    createSession: {
        __typename?: 'CreateSessionResponse';
        session: {
            __typename?: 'Session';
            vbIdentifier: string;
            sessionContext: {
                __typename?: 'SessionContext';
                customerType?: CustomerType | null;
                customerProcess?: CustomerProcess | null;
                customerSource?: CustomerSource | null;
                productType?: ProductType | null;
                shopType?: ShopType | null;
            };
        };
    };
};

export type SearchCustomerMutationVariables = Exact<{
    input: SearchCustomerInput;
}>;

export type SearchCustomerMutation = {
    __typename?: 'Mutation';
    searchCustomer: { __typename?: 'SearchCustomerResponse'; uuid: string };
};

export type UpdateSessionContextMutationVariables = Exact<{
    input: SessionContextInput;
}>;

export type UpdateSessionContextMutation = {
    __typename?: 'Mutation';
    updateSessionContext: {
        __typename?: 'SessionContext';
        shopType?: ShopType | null;
        productType?: ProductType | null;
        customerType?: CustomerType | null;
        customerProcess?: CustomerProcess | null;
        customerSource?: CustomerSource | null;
    };
};

export type AvailableProductsQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableProductsQuery = { __typename?: 'Query'; availableProducts?: Array<number> | null };

export type CustomerInformationByUuidQueryVariables = Exact<{
    uuid: Scalars['String']['input'];
}>;

export type CustomerInformationByUuidQuery = {
    __typename?: 'Query';
    customerInformation: {
        __typename?: 'CustomerInformation';
        contracts: {
            __typename?: 'Contracts';
            products: {
                __typename?: 'ContractProducts';
                dslOrder: {
                    __typename?: 'DslOrder';
                    installationAddress: {
                        __typename?: 'InstallationAddress';
                        address: {
                            __typename?: 'Address';
                            street: string;
                            houseNumber: string;
                            zip: string;
                            city: string;
                            klsId?: number | null;
                        };
                    };
                };
            };
        };
    };
};

export type ProductConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type ProductConfigurationQuery = {
    __typename?: 'Query';
    productConfiguration?: {
        __typename?: 'ProductConfiguration';
        product: number;
        options?: Array<number | null> | null;
        companionProducts?: Array<number | null> | null;
    } | null;
};

export type SearchResultUuidQueryVariables = Exact<{ [key: string]: never }>;

export type SearchResultUuidQuery = { __typename?: 'Query'; searchResultUuid: string };

export type SessionContextQueryVariables = Exact<{ [key: string]: never }>;

export type SessionContextQuery = {
    __typename?: 'Query';
    sessionContext: {
        __typename?: 'SessionContext';
        customerSource?: CustomerSource | null;
        customerProcess?: CustomerProcess | null;
        customerType?: CustomerType | null;
        productType?: ProductType | null;
        shopType?: ShopType | null;
    };
};

export type VerifiedAddressQueryVariables = Exact<{ [key: string]: never }>;

export type VerifiedAddressQuery = {
    __typename?: 'Query';
    verifiedAddress?: {
        __typename?: 'Address';
        street: string;
        houseNumber: string;
        zip: string;
        city: string;
        areaCode?: string | null;
    } | null;
};

export const CheckAvailabilityDocument = gql`
    mutation CheckAvailability($input: CheckAvailabilityInput!) {
        checkAvailability(input: $input)
            @rest(type: "Address", endpoint: "availability", path: "/availability", method: "POST") {
            address {
                areaCode
            }
            products
        }
    }
`;
export type CheckAvailabilityMutationFn = Apollo.MutationFunction<
    CheckAvailabilityMutation,
    CheckAvailabilityMutationVariables
>;

/**
 * __useCheckAvailabilityMutation__
 *
 * To run a mutation, you first call `useCheckAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAvailabilityMutation, { data, loading, error }] = useCheckAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckAvailabilityMutation(
    baseOptions?: Apollo.MutationHookOptions<CheckAvailabilityMutation, CheckAvailabilityMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CheckAvailabilityMutation, CheckAvailabilityMutationVariables>(
        CheckAvailabilityDocument,
        options
    );
}
export type CheckAvailabilityMutationHookResult = ReturnType<typeof useCheckAvailabilityMutation>;
export type CheckAvailabilityMutationResult = Apollo.MutationResult<CheckAvailabilityMutation>;
export type CheckAvailabilityMutationOptions = Apollo.BaseMutationOptions<
    CheckAvailabilityMutation,
    CheckAvailabilityMutationVariables
>;
export const CreateSessionDocument = gql`
    mutation CreateSession($input: CreateSessionInput!) {
        createSession(input: $input) @rest(type: "CreateSessionResponse", path: "/shop/session", method: "POST") {
            session @rest(type: "Session", path: "/auth/session") {
                vbIdentifier
                sessionContext {
                    customerType
                    customerProcess
                    customerSource
                    productType
                    shopType
                }
            }
        }
    }
`;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
}
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<
    CreateSessionMutation,
    CreateSessionMutationVariables
>;
export const SearchCustomerDocument = gql`
    mutation SearchCustomer($input: SearchCustomerInput!) {
        searchCustomer(input: $input)
            @rest(type: "SearchCustomerResponse", path: "/customer/contracts/search", method: "POST") {
            uuid
        }
    }
`;
export type SearchCustomerMutationFn = Apollo.MutationFunction<SearchCustomerMutation, SearchCustomerMutationVariables>;

/**
 * __useSearchCustomerMutation__
 *
 * To run a mutation, you first call `useSearchCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchCustomerMutation, { data, loading, error }] = useSearchCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCustomerMutation(
    baseOptions?: Apollo.MutationHookOptions<SearchCustomerMutation, SearchCustomerMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<SearchCustomerMutation, SearchCustomerMutationVariables>(SearchCustomerDocument, options);
}
export type SearchCustomerMutationHookResult = ReturnType<typeof useSearchCustomerMutation>;
export type SearchCustomerMutationResult = Apollo.MutationResult<SearchCustomerMutation>;
export type SearchCustomerMutationOptions = Apollo.BaseMutationOptions<
    SearchCustomerMutation,
    SearchCustomerMutationVariables
>;
export const UpdateSessionContextDocument = gql`
    mutation UpdateSessionContext($input: SessionContextInput!) {
        updateSessionContext(input: $input)
            @rest(type: "SessionContext", path: "/auth/session-context", method: "POST") {
            shopType
            productType
            customerType
            customerProcess
            customerSource
        }
    }
`;
export type UpdateSessionContextMutationFn = Apollo.MutationFunction<
    UpdateSessionContextMutation,
    UpdateSessionContextMutationVariables
>;

/**
 * __useUpdateSessionContextMutation__
 *
 * To run a mutation, you first call `useUpdateSessionContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionContextMutation, { data, loading, error }] = useUpdateSessionContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionContextMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateSessionContextMutation, UpdateSessionContextMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<UpdateSessionContextMutation, UpdateSessionContextMutationVariables>(
        UpdateSessionContextDocument,
        options
    );
}
export type UpdateSessionContextMutationHookResult = ReturnType<typeof useUpdateSessionContextMutation>;
export type UpdateSessionContextMutationResult = Apollo.MutationResult<UpdateSessionContextMutation>;
export type UpdateSessionContextMutationOptions = Apollo.BaseMutationOptions<
    UpdateSessionContextMutation,
    UpdateSessionContextMutationVariables
>;
export const AvailableProductsDocument = gql`
    query AvailableProducts {
        availableProducts @client
    }
`;

/**
 * __useAvailableProductsQuery__
 *
 * To run a query within a React component, call `useAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableProductsQuery(
    baseOptions?: Apollo.QueryHookOptions<AvailableProductsQuery, AvailableProductsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AvailableProductsQuery, AvailableProductsQueryVariables>(AvailableProductsDocument, options);
}
export function useAvailableProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AvailableProductsQuery, AvailableProductsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AvailableProductsQuery, AvailableProductsQueryVariables>(
        AvailableProductsDocument,
        options
    );
}
export type AvailableProductsQueryHookResult = ReturnType<typeof useAvailableProductsQuery>;
export type AvailableProductsLazyQueryHookResult = ReturnType<typeof useAvailableProductsLazyQuery>;
export type AvailableProductsQueryResult = Apollo.QueryResult<AvailableProductsQuery, AvailableProductsQueryVariables>;
export const CustomerInformationByUuidDocument = gql`
    query CustomerInformationByUuid($uuid: String!) {
        customerInformation(searchUuid: $uuid) @rest(type: "Customer", path: "/customer/contracts/{args.searchUuid}") {
            contracts {
                products {
                    dslOrder {
                        installationAddress {
                            address {
                                street
                                houseNumber
                                zip
                                city
                                klsId
                            }
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useCustomerInformationByUuidQuery__
 *
 * To run a query within a React component, call `useCustomerInformationByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInformationByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInformationByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCustomerInformationByUuidQuery(
    baseOptions: Apollo.QueryHookOptions<CustomerInformationByUuidQuery, CustomerInformationByUuidQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<CustomerInformationByUuidQuery, CustomerInformationByUuidQueryVariables>(
        CustomerInformationByUuidDocument,
        options
    );
}
export function useCustomerInformationByUuidLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CustomerInformationByUuidQuery, CustomerInformationByUuidQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<CustomerInformationByUuidQuery, CustomerInformationByUuidQueryVariables>(
        CustomerInformationByUuidDocument,
        options
    );
}
export type CustomerInformationByUuidQueryHookResult = ReturnType<typeof useCustomerInformationByUuidQuery>;
export type CustomerInformationByUuidLazyQueryHookResult = ReturnType<typeof useCustomerInformationByUuidLazyQuery>;
export type CustomerInformationByUuidQueryResult = Apollo.QueryResult<
    CustomerInformationByUuidQuery,
    CustomerInformationByUuidQueryVariables
>;
export const ProductConfigurationDocument = gql`
    query ProductConfiguration {
        productConfiguration @client {
            product
            options
            companionProducts
        }
    }
`;

/**
 * __useProductConfigurationQuery__
 *
 * To run a query within a React component, call `useProductConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductConfigurationQuery(
    baseOptions?: Apollo.QueryHookOptions<ProductConfigurationQuery, ProductConfigurationQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ProductConfigurationQuery, ProductConfigurationQueryVariables>(
        ProductConfigurationDocument,
        options
    );
}
export function useProductConfigurationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ProductConfigurationQuery, ProductConfigurationQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ProductConfigurationQuery, ProductConfigurationQueryVariables>(
        ProductConfigurationDocument,
        options
    );
}
export type ProductConfigurationQueryHookResult = ReturnType<typeof useProductConfigurationQuery>;
export type ProductConfigurationLazyQueryHookResult = ReturnType<typeof useProductConfigurationLazyQuery>;
export type ProductConfigurationQueryResult = Apollo.QueryResult<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
>;
export const SearchResultUuidDocument = gql`
    query SearchResultUuid {
        searchResultUuid @client
    }
`;

/**
 * __useSearchResultUuidQuery__
 *
 * To run a query within a React component, call `useSearchResultUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResultUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchResultUuidQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchResultUuidQuery(
    baseOptions?: Apollo.QueryHookOptions<SearchResultUuidQuery, SearchResultUuidQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchResultUuidQuery, SearchResultUuidQueryVariables>(SearchResultUuidDocument, options);
}
export function useSearchResultUuidLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchResultUuidQuery, SearchResultUuidQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchResultUuidQuery, SearchResultUuidQueryVariables>(
        SearchResultUuidDocument,
        options
    );
}
export type SearchResultUuidQueryHookResult = ReturnType<typeof useSearchResultUuidQuery>;
export type SearchResultUuidLazyQueryHookResult = ReturnType<typeof useSearchResultUuidLazyQuery>;
export type SearchResultUuidQueryResult = Apollo.QueryResult<SearchResultUuidQuery, SearchResultUuidQueryVariables>;
export const SessionContextDocument = gql`
    query SessionContext {
        sessionContext @rest(type: "SessionContext", path: "/auth/session-context") {
            customerSource
            customerProcess
            customerType
            productType
            shopType
        }
    }
`;

/**
 * __useSessionContextQuery__
 *
 * To run a query within a React component, call `useSessionContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionContextQuery(
    baseOptions?: Apollo.QueryHookOptions<SessionContextQuery, SessionContextQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SessionContextQuery, SessionContextQueryVariables>(SessionContextDocument, options);
}
export function useSessionContextLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SessionContextQuery, SessionContextQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SessionContextQuery, SessionContextQueryVariables>(SessionContextDocument, options);
}
export type SessionContextQueryHookResult = ReturnType<typeof useSessionContextQuery>;
export type SessionContextLazyQueryHookResult = ReturnType<typeof useSessionContextLazyQuery>;
export type SessionContextQueryResult = Apollo.QueryResult<SessionContextQuery, SessionContextQueryVariables>;
export const VerifiedAddressDocument = gql`
    query VerifiedAddress {
        verifiedAddress @client {
            street
            houseNumber
            zip
            city
            areaCode
        }
    }
`;

/**
 * __useVerifiedAddressQuery__
 *
 * To run a query within a React component, call `useVerifiedAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiedAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiedAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifiedAddressQuery(
    baseOptions?: Apollo.QueryHookOptions<VerifiedAddressQuery, VerifiedAddressQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<VerifiedAddressQuery, VerifiedAddressQueryVariables>(VerifiedAddressDocument, options);
}
export function useVerifiedAddressLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<VerifiedAddressQuery, VerifiedAddressQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<VerifiedAddressQuery, VerifiedAddressQueryVariables>(VerifiedAddressDocument, options);
}
export type VerifiedAddressQueryHookResult = ReturnType<typeof useVerifiedAddressQuery>;
export type VerifiedAddressLazyQueryHookResult = ReturnType<typeof useVerifiedAddressLazyQuery>;
export type VerifiedAddressQueryResult = Apollo.QueryResult<VerifiedAddressQuery, VerifiedAddressQueryVariables>;
